import React, { useState } from 'react';
import { ListItem, Stack, Typography } from '@mui/material';
import AssetLogo from '../sections/AssetLogo';
import { getUserProfileFullName } from '../utils/users';
import CopyTextIconButton from './CopyTextIconButton';
import CustomTooltip from 'components/CustomTooltip';
import { User } from '../graphql/types';
interface UserListItemProps {
  userData: Partial<User>;
  role?: string;
  fontSize?: number;
  showCompany?: boolean;
  showCopyButton?: boolean;
}

const UserListItem = ({ userData, role, fontSize = 14, showCompany = false, showCopyButton = true }: UserListItemProps) => {
  const fullNameCombined = getUserProfileFullName(userData);
  const hasCompany = showCompany && userData?.company && userData?.company?.id != null;

  const logo = hasCompany ? userData.company?.logo : userData?.data?.avatar;
  const topLineText = hasCompany ? fullNameCombined : role;
  const bottomLineText = hasCompany ? userData.company?.legalName : fullNameCombined;
  const [hovered, setHovered] = useState(false);

  return (
    <ListItem onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} sx={{ position: 'relative', '&&': { pb: 0.5 } }}>
      <Stack direction="row" spacing={1} alignItems="center" flex={1}>
        <Stack width="42px" justifyContent="flex-start">
          <AssetLogo logo={logo} name={bottomLineText} size="sm" />
        </Stack>

        <Stack spacing={0} alignItems="flex-start" width="100%">
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" sx={{ height: 16 }}>
            <CustomTooltip placement="top" title={topLineText}>
              <Typography
                noWrap
                fontSize={fontSize}
                color="#979797"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  '@media (min-width: 1280px) and (max-width: 1700px)': { maxWidth: '110px' },
                  '@media (min-width: 1700px) and (max-width: 1950px)': { maxWidth: '150px' }
                }}
              >
                {topLineText}
              </Typography>
            </CustomTooltip>
            {showCopyButton && hovered && hasCompany && <CopyTextIconButton textToCopy={topLineText || ''} dispatchText="User Name" />}
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" sx={{ height: 20 }}>
            <CustomTooltip placement="top" title={bottomLineText}>
              <Typography
                noWrap
                textAlign="left"
                fontSize={12}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  '@media (min-width: 1280px) and (max-width: 1700px)': { maxWidth: '110px' },
                  '@media (min-width: 1700px) and (max-width: 1950px)': { maxWidth: '150px' }
                }}
              >
                {bottomLineText}
              </Typography>
            </CustomTooltip>

            {showCopyButton && hovered && (
              <CopyTextIconButton textToCopy={bottomLineText || ''} dispatchText={hasCompany ? 'Company Name' : 'User Name'} />
            )}
          </Stack>
        </Stack>
      </Stack>
    </ListItem>
  );
};

export default UserListItem;
